/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface EsercenteRegistrationForm { 
    email: string;
    ragione_sociale: string;
    partita_iva: string;
    pec?: string;
    sede_legale?: string;
    indirizzo_sede?: string;
    iban?: string;
    cciaa?: string;
    termini_accettati?: boolean;
    termini_versione?: string;
}

